<template>
  <div id="app">
    <el-container :class="{ 'not-auth': !this.$store.state.auth.isLoggedIn }" :style="{ width: '100%' }">
      <!-- Migration Banner for Nova Organizations -->
      <migration-banner
        v-if="novaOrgId && this.$store.state.auth.isLoggedIn && isUserMigratedToNova"
        :novaOrgId="novaOrgId"
        :productType="productType"
      />
      <el-header class="header">
        <el-row class="header__inner">
          <el-col :span="12">
            <div class="elsa-logo">
              <img src="@/assets/images/elsa-dashboard-logo.svg" alt="Elsa Now" />
            </div>
          </el-col>
          <el-col :span="12" v-if="this.$store.state.auth.isLoggedIn" id="nav-right">
            <user-dropdown />
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-aside
          v-if="this.$store.state.auth.isLoggedIn && $route.name !== 'admin' && $route.name !== 'comming-soon' && $route.name !== 'access-notice'"
          width="240px"
        >
          <el-menu :default-active="activeNav" class="el-menu-vertical-demo" ref="menu">
            <el-menu-item index="1" v-if="!isUserMigratedToNova && canAccessGetSetup">
              <router-link
                id="left-navigation-get-set-up-button"
                :to="'/admin/organization/' + currentOrganizationId + '/onboarding'"
              >
                <rocket-icon width="50px" />
                <span>{{ $t("menu.get_set_up") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="7" v-if="canAccessDashboard">
              <router-link
                id="left-navigation-dashboard-button"
                :to="{
                  name: 'dashboard',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <dashboard-icon width="50px" />
                <span>{{ $t("menu.dashboard") }}</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="3" v-if="canAccessClasses">
              <router-link
                id="left-navigation-classes-button"
                :to="{
                  name: 'classes',
                  params: { organizationId: currentOrganizationId },
                }"
              >
                <team-icon width="50px" />
                <span>{{ $t($i18nLabelsHelper(currentOrganizationType, "groups")) }}</span>
              </router-link>
            </el-menu-item>
            <template v-if="!isUserMigratedToNova">
              <el-menu-item index="4" v-if="canAccessTeachers">
                <router-link
                  id="left-navigation-teachers-button"
                  :to="{
                    name: 'teachers',
                    params: { organizationId: currentOrganizationId },
                  }"
                >
                  <team-lead-icon width="48px" style="padding-left:2px" />
                  <span>{{ $t($i18nLabelsHelper(currentOrganizationType, "teachers")) }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="9" v-if="canAccessCurriculum">
                <router-link
                  id="left-navigation-plan-button"
                  :to="{
                    name: 'studysets',
                    params: { organizationId: currentOrganizationId },
                  }"
                >
                  <curriculum-icon width="47px" style="padding-left:3px" />
                  <span>{{ $t("menu.curriculum") }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="5" v-if="canAccessStudents">
                <router-link
                  id="left-navigation-students-button"
                  :to="{
                    name: 'students',
                    params: { organizationId: currentOrganizationId },
                  }"
                >
                  <learners-icon width="47px" style="padding-left:3px" />
                  <span>{{ $t("menu.learners") }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="6" v-if="canAccessPlanPayment">
                <router-link
                  id="left-navigation-plan-button"
                  :to="'/admin/organization/' + currentOrganizationId + '/plan'"
                >
                  <payment-icon width="50px" />
                  <span>{{ $t("menu.plan_payment") }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="2" v-if="isElsaAdmin || isOrganizationAdmin">
                <router-link id="left-navigation-account-button" :to="'/admin/organization/' + currentOrganizationId">
                  <setting-icon width="50px" />
                  <span>{{ $t("menu.account") }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item hidden index="10" v-show="isShowMenuBranches">
                <router-link
                  id="left-navigation-account-button"
                  :to="'/organization/' + currentOrganizationId + '/branches'"
                >
                  <organization-icon width="47px" style="padding-left:3px" />
                  <span>{{ $t("menu.branch") }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="8" v-if="isElsaAdmin">
                <router-link id="left-navigation-organizations-button" to="/admin">
                  <organization-icon width="47px" style="padding-left:3px" />
                  <span>{{ $t("menu.organizations") }}</span>
                </router-link>
              </el-menu-item>
              <el-menu-item index="11" v-if="isElsaAdmin && currentOrganizationId">
                <router-link
                  id="left-navigation-organizations-button"
                  :to="'/admin/organization/' + currentOrganizationId + '/internal-payment'"
                >
                  <payment-icon width="50px" />
                  <span>{{ $t("menu.internal_payment") }}</span>
                </router-link>
              </el-menu-item>

            </template>
            
          </el-menu>
          <last-login />
        </el-aside>
        <invite />
        <router-view />
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { path, includes } from "ramda";
import { mapGetters } from "vuex";
import Invite from "@/components/common/Invite";
import UserDropdown from "@/components/common/UserDropdown";
import learnersIcon from "@/assets/images/inline.profile-icon.svg";
import settingIcon from "@/assets/images/inline.setting-icon.svg";
import organizationIcon from "@/assets/images/inline.organization-icon.svg";
import teamIcon from "@/assets/images/inline.team-icon.svg";
import rocketIcon from "@/assets/images/inline.rocket-icon.svg";
import paymentIcon from "@/assets/images/inline.payment-icon.svg";
import dashboardIcon from "@/assets/images/inline.dashboard-icon.svg";
import teamLeadIcon from "@/assets/images/inline.team-lead-icon.svg";
import curriculumIcon from "@/assets/images/inline.curriculum-icon.svg";
import LastLogin from "@/components/common/LastLogin/LastLogin.vue";
import MigrationBanner from "@/components/common/MigrationBanner.vue";

export default {
  components: {
    Invite,
    UserDropdown,
    learnersIcon,
    teamIcon,
    rocketIcon,
    paymentIcon,
    settingIcon,
    dashboardIcon,
    teamLeadIcon,
    organizationIcon,
    curriculumIcon,
    LastLogin,
    MigrationBanner
  },
  data() {
    return {
      activeNav: "1",
      navConfig: {
        onboarding: "1",
        dashboard: "7",
        classes: "3",
        teachers: "4",
        students: "5",
        organizationplan: "6",
        organization: "2",
        insights: "12",
      },
      watchRoute: true,
      isEmptyOrg: false,
      SARoutes: ["students", "account"],
      nonOrgRoutes: ["admin", "comming-soon", "access-notice", "prohibited"],
      allowedStudentRoutes: ["comming-soon", "dashboard", "classes", "class-details", "student-details"],
      accessibleMigratedRoutes: ['dashboard', 'classes', 'class-details', 'Login'],
      redirectingToDashboard: false, // Flag to prevent repeated redirects
    };
  },
  computed: {
    ...mapGetters("user", ["isElsaAdmin"]),
    ...mapGetters("organization", [
      "isOrganizationAdmin",
      "isOrganizationAssociateAdmin",
      "isOrganizationTeacher",
      "isOrganizationStudent",
      "currentOrganizationType",
      "currentOrgPayment",
      "userOrganizations",
      "hasChildOrg",
      "isElsaSpeakProduct",
      "SAonly",
      "isNovaOrg",
      "isUserMigratedToNova",
      "isOrganizationK12"
    ]),
    productType() {
      return this.isOrganizationK12 ? 'ELSA School' : 'ELSA Business';
    },
    currentOrganizationId() {
      let organizationId = this.$store.state.organization.currentOrganizationId;
      return organizationId;
    },
    currentOrganization() {
      return this.$store.state.organization.currentOrganization;
    },
    novaOrgId() {
      if (!this.currentOrganization) {
        return '';
      }
      return this.currentOrganization.new_org;
    },
    canAccessCurriculum() {
      return (
        (this.isOrganizationTeacher || this.isOrganizationAdmin || this.isOrganizationAssociateAdmin) &&
        this.currentOrganizationId &&
        this.isElsaSpeakProduct &&
        !this.isNovaOrg
      );
    },
    canAccessClasses() {
      return (
        (this.isOrganizationAdmin ||
          this.isOrganizationAssociateAdmin ||
          this.$store.getters["organization/hasOrganizations"]) &&
        this.currentOrganizationId &&
        this.isElsaSpeakProduct
      );
    },
    canAccessTeachers() {
      return (
        (this.isOrganizationAdmin || this.isOrganizationAssociateAdmin) &&
        this.currentOrganizationId &&
        this.isElsaSpeakProduct
      );
    },
    canAccessStudents() {
      return (
        (this.isOrganizationTeacher || this.isOrganizationAdmin || this.isOrganizationAssociateAdmin) &&
        this.currentOrganizationId
      );
    },
    canAccessDashboard() {
      return (
        ((this.isElsaAdmin && this.currentOrganizationId) || (!this.isElsaAdmin && this.isElsaSpeakProduct)) &&
        !this.isNovaOrg
      );
    },
    canAccessGetSetup() {
      return (
        (this.isElsaAdmin || this.isOrganizationAdmin || this.isOrganizationAssociateAdmin || this.isEmptyOrg) &&
        this.isElsaSpeakProduct
      );
    },
    canAccessPlanPayment() {
      return (this.isElsaAdmin || this.isOrganizationAdmin) && this.isElsaSpeakProduct && !this.isNovaOrg;
    },
    isShowMenuBranches() {
      if (!this.hasChildOrg) return false;
      return this.hasChildOrg && (this.isElsaAdmin || this.isOrganizationAdmin);
    },
  },
  methods: {
    checkMigrationAndRedirect() {
      // Check if organization is migrated to Nova and current route is not accessible
      if (this.isUserMigratedToNova && this.$store.state.auth.isLoggedIn) {
        const currentRouteName = this.$route.name;
        const organizationId = this.$route.params.organizationId;
        
        // Don't redirect if we're already on the dashboard or already redirecting
        if (currentRouteName === 'dashboard' || this.redirectingToDashboard) {
          return;
        }
        
        // Check if current route is not in accessible migrated routes
        if (!this.accessibleMigratedRoutes.includes(currentRouteName)) {
          // Set flag to prevent repeated redirects
          this.redirectingToDashboard = true;
          
          this.$router.push({ 
            name: "dashboard", 
            params: { organizationId } 
          }).then(() => {
            // Reset flag after navigation completes
            this.$nextTick(() => {
              this.redirectingToDashboard = false;
            });
          }).catch(() => {
            // Reset flag even if navigation fails
            this.redirectingToDashboard = false;
          });
        }
      }
    },
  },
  watch: {
    async $route(to, from) {
      let forceActiveNav;
      const toOrganizationId = path(["params", "organizationId"], to); // Extracts org ID from URL

      // --- Organization ID Handling ---
      if (toOrganizationId && /^\d+$/.test(toOrganizationId)) { // Case 1: Organization ID IS in the URL
        // Check if the full organization object is already in the store.
        // `this.currentOrganization` accesses `this.$store.state.organization.currentOrganization`
        if (Object.keys(this.currentOrganization).length === 0) {
          // If not, dispatch an action to fetch and set it in the store.
          // This action will likely make an API call and then commit mutations
          // to update `state.organization.currentOrganization` and `state.organization.currentOrganizationId`.
          await this.$store.dispatch("organization/setCurrentOrganization", {
            organizationId: Number(toOrganizationId),
          });
          // This dispatch ensures `state.organization.currentOrganizationId` is set.
          // It might be slightly redundant if setCurrentOrganization already sets the ID,
          // but ensures the ID is explicitly updated.
          this.$store.dispatch("organization/setCurrentOrganizationId", {
            organizationId: Number(toOrganizationId),
          });
        }
        // `this.SAonly` is a getter from the `organization` store.
        // It checks if the current organization has specific product limitations (Speech Analyzer only).
        if (this.SAonly && !includes(to.name)(this.SARoutes)) {
          this.$router.push(`/admin/organization/${toOrganizationId}/students`);
        }
      } else { // Case 2: Organization ID is NOT in the URL
        // `this.$store.state.auth.isLoggedIn` checks the login status from the `auth` module's state.
        if (this.$store.state.auth.isLoggedIn && !this.nonOrgRoutes.includes(to.name)) {
          // Try to get a fallback organization ID.
          // `this.currentOrganizationId` accesses `this.$store.state.organization.currentOrganizationId`.
          let _toOrganizationId = this.currentOrganizationId;

          // If no `currentOrganizationId` is in the store,
          // `this.userOrganizations` (a getter from the `organization` store, providing a list
          // of organizations the user belongs to) is used to pick the first one as a default.
          if (!_toOrganizationId && this.userOrganizations && this.userOrganizations.length > 0) {
            // MODIFIED: Find the first classic organization
            const classicOrg = this.userOrganizations.find(org => !org.is_nova);
            if (classicOrg) {
              _toOrganizationId = classicOrg.id;
            } else {
              // If no classic org, redirect to access-notice. This case should ideally be handled
              // by the logic in section 2, but this is a fallback.
              this.$router.push({ name: 'access-notice' });
              return; // Stop further processing in the watcher
            }
          }

          if (_toOrganizationId) {
            // If an organization ID is found (either from store or user's list),
            // redirect to its onboarding page. This implicitly sets the organization context
            // in the URL, and the watcher will run again, this time hitting Case 1.
            // However, don't redirect migrated organizations to onboarding as they can't access it
            if (this.isUserMigratedToNova) {
              this.$router.push(`/organization/${_toOrganizationId}/dashboard`);
            } else {
              this.$router.push(`/admin/organization/${_toOrganizationId}/onboarding`);
            }
          } else {
            // No organization ID could be determined (e.g., new user, no orgs assigned).
            // Set local component state and redirect to a generic onboarding.
             if (this.isUserMigratedToNova) {
              this.$router.push(`/organization/${_toOrganizationId}/dashboard`);
            } else {
              this.isEmptyOrg = true;
              forceActiveNav = "1"; // Force "Get Set Up" menu
              this.$router.push(`/onboarding`);
            }
          }
        }
      }

      // --- reCAPTCHA Visibility --- (No direct store interaction shown here)
      if (this.$recaptchaInstance) {
        if (to.name === "Login") {
          this.$recaptchaInstance.showBadge();
        } else {
          this.$recaptchaInstance.hideBadge();
        }
      }

      // --- Active Navigation Menu Item ---
      if (this.watchRoute || from.name === "admin" || from.name === "Login") {
        if (forceActiveNav) {
          this.activeNav = forceActiveNav;
        } else if (to.name in this.navConfig) {
          this.activeNav = this.navConfig[to.name];
        } else if (to.meta && to.meta.menuItemIndex) {
          this.activeNav = to.meta.menuItemIndex;
        }
        this.watchRoute = false;
      }

      // --- Document Title ---
      document.title = to.meta.title || this.$t("common.elsa_dashboard");

      // --- Final Active Navigation Check ---
      // Ensures menu item is correctly highlighted if metadata provides an index
      // and it differs from the currently set activeNav (and not forced).
      if (to.meta.menuItemIndex && this.activeNav && !forceActiveNav && to.meta.menuItemIndex !== this.activeNav) {
        this.activeNav = to.meta.menuItemIndex;
      }

      // --- Migration Check ---
      // Only check migration if we're not already on the dashboard and not currently redirecting
      if (to.name !== 'dashboard' && !this.redirectingToDashboard) {
        this.checkMigrationAndRedirect();
      }

    },
    isUserMigratedToNova(newValue) {
      // If the user is migrated to Nova, redirect to dashboard for non-accessible routes      
      if (newValue && this.$route.name !== 'dashboard' && !this.redirectingToDashboard) {
        this.checkMigrationAndRedirect();
      }
    },
  },
};
</script>
<style lang="scss">
@import "./scss/global.scss";
.el-container {
  min-height: calc(100vh - 80px);
}
.user-menu {
  p {
    margin: 0;
    line-height: 1;
    &.description {
      text-transform: uppercase;
      color: $light-blue-2;
      font-size: 10px;
      margin-bottom: 16px;
    }
    &.link {
      font-size: 16px;
      text-transform: capitalize;
      color: $gray;
      font-weight: 500;
      cursor: pointer;

      &:not(.logout) {
        margin-bottom: 32px;
      }
      &.logout {
        border-top: 1px solid rgba(206, 224, 234, 0.5);
        padding-top: 16px;
        padding-bottom: 8px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
          text-decoration-color: $purple;
        }
      }
    }
  }
}

.logout-link {
  cursor: pointer;
  font-size: 14px;
  text-transform: capitalize;
  color: #eb5757;
}

.divider {
  border-width: 2px;
}

.switch-lang {
  margin: 0 20px;
}

@media only screen and (max-width: 768px) {
  .switch-lang {
    margin-bottom: -5px;
    position: absolute;
    top: 5px;
    right: 5px;
  }
}

.header {
  height: 64px !important;
  margin-top: 16px;
  border-bottom: solid 1px #e6e6e6;

  .header__inner {
    display: flex;
  }
}

.el-menu-item {
  font-size: 16px;
  line-height: 48px;
  height: 48px;
  color: #121131;
  font-weight: 500;
  margin-bottom: 8px;
  border-radius: 8px;
}

ul.el-menu-vertical-demo.el-menu {
  padding-left: 16px;
  padding-top: 16px;
  padding-right: 16px;
  background-color: #ffffff !important;
  height: 100%;
}

ul.el-menu-vertical-demo.el-menu li a {
  display: block;
  width: calc(100% + 20px);
  margin-left: -20px;
  padding-left: 20px;
}

.el-menu-item:hover,
.el-menu-item:focus {
  border-radius: 8px;
  font-weight: 700;
}

.el-menu-item.is-active,
.el-menu-item.is-active:hover {
  color: #007eff;
  background-color: RGB(71, 141, 255, 0.1) !important;
  border-radius: 8px;

  svg {
    filter: invert(42%) sepia(78%) saturate(1707%) hue-rotate(202deg) brightness(104%) contrast(101%);
  }
}

#left-navigation-dashboard-button {
  svg {
    width: 50px;
  }
}

.user-badge {
  text-align: right;
}

.el-menu-item a {
  color: inherit;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
}

.not-auth {
  .el-header {
    display: none !important;
  }
  .el-container {
    display: block;
  }
  .switch-lang {
    position: absolute;
    right: 52%;
    top: 43px;
    z-index: 999;
  }
}
.el-aside {
  position: sticky;
  top: 0;
  max-height: 100vh;
  overflow: hidden;
}

#nav-right {
  margin: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
